module.exports = __webpack_public_path__ + "img/barespend-easy-reimburse.59886c67.png";